import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthContext = createContext({ user: null, setUser: () => {}, logout: () => {} });

const fetchMe = async () => {
  try {
    return (await api.get("/auth/me")).data;
  } catch {
    await api.post("/auth/refresh");
    return (await api.get("/auth/me")).data;
  }
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Skip while returning from Google: AuthCallback establishes the session first.
    if (window.location.hash?.includes("session_id=")) return;
    fetchMe().then(setUser).catch(() => setUser(false));
  }, []);

  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  }, []);

  return <AuthContext.Provider value={{ user, setUser, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
